import { Icon } from './Icon.js';

/**
 * A country's flag, as an image.
 *
 * Not emoji: Windows ships no flag glyphs and shows the two letters instead. The
 * images are flag-icons (MIT), kept as separate files by vite.config.ts so a
 * browser fetches only the flags actually on screen.
 *
 * Satellite and international network ranges have no flag, and get a globe.
 */
const FILES = import.meta.glob<string>(['@flags/??.svg', '@flags/sh-ac.svg'], {
  eager: true, query: '?url', import: 'default', exhaustive: true,
});

const BY_CODE = new Map<string, string>();
for (const [path, url] of Object.entries(FILES)) {
  const name = path.slice(path.lastIndexOf('/') + 1, -'.svg'.length);
  // Ascension Island is filed under St Helena, Ascension and Tristan da Cunha.
  BY_CODE.set(name === 'sh-ac' ? 'AC' : name.toUpperCase(), url);
}

export function Flag({ iso2 }: { iso2: string }) {
  const src = BY_CODE.get(iso2.toUpperCase());
  if (!src) {
    return (
      <span className="arc-flag arc-flag-none" aria-hidden="true">
        <Icon name="globe" size={12} />
      </span>
    );
  }
  // The name is always written beside it, so the image itself says nothing.
  return <img className="arc-flag" src={src} alt="" loading="lazy" />;
}
